import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, Groups, PRODUCT_GROUP } from '@/core';

export const useGroups = ({ page, limit }: { page: number; limit: number }) => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${PRODUCT_GROUP}`;

  const useGroupsSearch = (search: string) =>
    useQuery<Groups>({
      queryKey: ['groupsSearch', search],
      queryFn: async () => {
        if (search === '') return [];
        const response = await axiosInstance.get(`${fullUrl}/search`, { params: { name: search } });
        return response.data;
      },
    });

  const useGroupsQuery = useQuery<Groups>({
    queryKey: ['groups', page, limit],
    queryFn: () => axiosInstance.get(fullUrl, { params: { page, limit } }).then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    enabled: true,
  });

  return {
    useGroupsQuery,
    useGroupsSearch,
  };
};
